
import { useAxios } from '../../../../../../hooks/useAxios';
import { AlquilerAdapters, AlquileresAdapters } from '../adapters/alquileres.adapter';

const AlquileresServices = {

    GET: function () {

        return useAxios({ method: 'get', url: `/slam/pedidos`, type: 'json', adapters: AlquileresAdapters.GET })
    },

    GET_CHECK_DISPONIBILIDAD: function () {

        return useAxios({ method: 'GET', url: `/slam/pedidos/check-disponibility`, type: 'json', adapters: AlquileresAdapters.GET_CHECK_DISPONIBILIDAD })
    },

    GET_TARIFAS_CONDICIONES_PAGO: function () {

        return useAxios({ method: 'GET', url: `/slam/pedidos/get-tarifas-condicionespagos`, type: 'json', adapters: AlquileresAdapters.GET_TARIFAS_CONDICIONES_PAGO })
    },

    GET_CONDICIONES_PAGO: function () {

        return useAxios({ method: 'GET', url: `/slam/pedidos/get-condicionespagos`, type: 'json', adapters: AlquileresAdapters.GET_CONDICIONES_PAGO })
    },
}

const AlquilerServices = {

    GET: function (id: string) {

        return useAxios({ method: 'get', url: `/slam/pedidos/${id}`, type: 'json', adapters: AlquilerAdapters.GET })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/slam/pedidos-admin/create`, type: 'json', adapters: AlquilerAdapters.POST })
    },

    PATCH: function (id: string) {

        return useAxios({ method: 'patch', url: `/slam/pedidos/${id}/update`, type: 'json', adapters: AlquilerAdapters.PATCH })
    },

    PATCH_CAMBIAR_ESTADO: function (id: string) {

        return useAxios({ method: 'patch', url: `/slam/pedidos/${id}/change-state`, type: 'json', adapters: AlquilerAdapters.PATCH_CAMBIAR_ESTADO })
    },

    POST_GENERAR_FACTURA: function () {

        return useAxios({ method: 'post', url: `/slam/pedidos/generar-factura`, type: 'json', adapters: AlquilerAdapters.POST_GENERAR_FACTURA })
    },
}

export {
    AlquileresServices,
    AlquilerServices
}